import React from "react";
import LegalPage from "./LegalPage";

const sections = [
  {
    title: "1. Общие положения",
    paragraphs: [
      "1.1. Настоящая публичная оферта (далее - «Оферта», «Договор») является официальным предложением Индивидуального предпринимателя СКОРЯБКИНА АЛЕКСАНДРА ВАЛЕРЬЕВНА, ИНН 781602232900, ОГРНИП 325784700307756, (далее - «Исполнитель») заключить договор возмездного оказания услуг на условиях, изложенных в настоящем документе.",
      "1.2. Оферта адресована физическим лицам и индивидуальным предпринимателям, действующим лично или в интересах несовершеннолетних детей (далее - «Покупатель»).",
      "1.3. Настоящая Оферта вступает в силу с момента размещения по постоянной ссылке и действует до её изменения или отзыва Исполнителем.",
      "1.4. Исполнитель вправе в любое время изменять условия Оферты. Новые условия вступают в силу с даты публикации по постоянной ссылке, если не указано иное.",
      "1.5. Договор считается заключённым с момента акцепта Оферты Покупателем, что подтверждается оплатой подписки через Telegram-бота @freshcasting_bot.",
    ],
  },
  {
    title: "2. Термины и определения",
    paragraphs: [
      "2.1. Оферта - настоящее публичное предложение Исполнителя.",
      "2.2. Акцепт - полное и безоговорочное принятие условий Оферты Покупателем путём оплаты подписки.",
      "2.3. Telegram-бот - автоматизированный бот @freshcasting_bot, через который оформляется подписка.",
      "2.4. Сервис - функционал Telegram-бота, обеспечивающий доступ к закрытому Telegram-каналу с кастингами.",
      "2.5. Закрытый Telegram-канал - канал, доступ в который предоставляется после оплаты подписки.",
      "2.6. Подписка - платная услуга доступа на определённый период.",
      "2.7. Период подписки - срок действия доступа к закрытому каналу.",
    ],
  },
  {
    title: "3. Предмет договора",
    paragraphs: [
      "3.1. Исполнитель обязуется предоставить Покупателю доступ к закрытому Telegram-каналу с актуальными кастингами для детей и подростков на срок, соответствующий оплаченной подписке, а Покупатель обязуется оплатить подписку.",
      "3.2. Исполнитель предоставляет доступ без передачи исключительных или иных прав на Telegram-бот или канал.",
    ],
  },
  {
    title: "4. Акцепт и оказание услуг",
    paragraphs: [
      "4.1. Актуальные виды подписок и их стоимость указаны в интерфейсе Telegram-бота.",
      "4.2. Подписка считается оплаченной с момента подтверждения платёжной системой успешного проведения оплаты на счёт Исполнителя.",
      "4.3. После оплаты бот автоматически предоставит доступ к закрытому Telegram-каналу на оплаченный период.",
      "4.4. Доступ автоматически прекращается после окончания оплаченного периода.",
    ],
  },
  {
    title: "5. Права и обязанности сторон",
    paragraphs: ["5.1. Исполнитель обязуется предоставить доступ в соответствии с выбранной подпиской и размещать в канале актуальные объявления о кастингах.", "5.2. Покупатель обязуется указывать достоверные данные при оформлении подписки и не передавать доступ третьим лицам."],
  },
  {
    title: "6. Стоимость услуг и порядок расчётов",
    paragraphs: [
      "6.1. Стоимость подписки указана в Telegram-боте и/или на сайте Исполнителя.",
      "6.2. Оплата производится через интегрированные платёжные сервисы (например, ЮKassa) с использованием банковских карт либо иных способов, доступных в бот-интерфейсе.",
      "6.3. Подписка считается оплаченной с момента зачисления средств на счёт Исполнителя.",
    ],
  },
  {
    title: "7. Возврат денежных средств",
    paragraphs: [
      "7.1. Покупатель признаёт и соглашается, что доступ к закрытому Telegram-каналу является электронной услугой с немедленным предоставлением доступа.",
      "7.2. После предоставления доступа возврат денежных средств не осуществляется, так как услуга считается оказанной.",
      "7.3. Возврат средств возможен только в исключительных случаях технических ошибок (например, двойное списание) при обращении в службу поддержки в течение 24 часов после оплаты. Решение о возврате принимает Исполнитель.",
    ],
  },
  {
    title: "8. Ограничение ответственности",
    paragraphs: [
      "8.1. Исполнитель предоставляет информационный контент и не гарантирует участие Пользователя в кастингах, результаты участия или соответствие информации ожиданиям Покупателя.",
      "8.2. Исполнитель не несёт ответственности за действия заказчиков кастингов, сбои Telegram и платёжных систем, любые убытки Покупателя, прямые или косвенные.",
      "8.3. Исполнитель не является агентом или посредником между Пользователем и организаторами кастингов.",
    ],
  },
  {
    title: "9. Обработка персональных данных",
    paragraphs: [
      "9.1. Акцепт Оферты означает согласие Покупателя на обработку персональных данных в объёме, необходимом для исполнения настоящего Договора, в соответствии с Федеральным законом № 152-ФЗ «О персональных данных».",
      "9.2. Порядок обработки данных изложен в отдельной Политике обработки персональных данных, размещённой по отдельной ссылке.",
    ],
  },
  {
    title: "10. Прекращение договора",
    paragraphs: ["10.1. Договор действует с момента акцепта до окончания оплаченного периода подписки.", "10.2. Исполнитель вправе ограничить или прекратить доступ за нарушение условий Оферты."],
  },
  {
    title: "11. Урегулирование споров",
    paragraphs: ["11.1. Споры решаются путём переговоров.", "11.2. Если соглашение не достигнуто, спор передаётся в суд по месту нахождения Исполнителя в соответствии с законодательством РФ."],
  },
  {
    title: "12. Прочие условия",
    paragraphs: ["12.1. Вопросы, не урегулированные договором, подлежат решению в соответствии с законодательством РФ.", "12.2. Недействительность отдельного пункта не влечёт недействительности всего договора."],
  },
  {
    title: "13. Реквизиты Исполнителя",
    paragraphs: ["Индивидуальный предприниматель\nСКОРЯБКИНА АЛЕКСАНДРА ВАЛЕРЬЕВНА\nИНН: 781602232900\nОГРНИП: 325784700307756\nБанк: АО «ТБанк»\nР/с: 40802810700008713689\nБИК: 044525974\nКорр. счёт: 30101810145250000974\nИНН банка: 7710140679\nЮридический адрес банка: 127287, г. Москва, ул. Хуторская 2-я, д. 38А, стр. 26"],
  },
];

const OfferPage = () => <LegalPage title="Публичная оферта" subtitle="На использование сервиса @freshcasting_bot и предоставление доступа к закрытому Telegram-каналу с кастингами. Дата вступления в силу: 01 января 2026 года." sections={sections} />;

export default OfferPage;
